'use client';

import React, { Suspense, useEffect, useRef, useState } from 'react'

import Link from 'bwax-ui/page/Link'

import clsx from 'clsx';
import WindowScrollHelper from 'bwax-ui/helpers/WindowScrollHelper';

import getImageURL from 'bwax-ui/getImageURL'

import Button, { Pressable } from 'bwax-ui/components/Button.tsx'

import { useTrack } from 'bwax-ui/track';

import { usePathname, useRouter, useSearchParams } from 'next/navigation'

// import PopoverTrigger from 'bwax-ui/components/PopoverTrigger';
import DropdownMenu from 'bwax-ui/components/DropdownMenu';
import { DataLoaderProvider } from '../../store/DataLoaderContext';

import Image from "next/image";

export default function Layout001(props) {

    const { data = {}, slots = {}, viewEnv = {} } = props;

    const track = useTrack();

    const pathname = usePathname();

    const {
        logoPC, logoMobile,

        logoPCForDark,

        homeUrl = "/home",

        tryButtonLabel = "立即体验",
        tryButtonOpenNewWindow = true,

        tryUrl = "/signup",
        siteName,

        mainColor = "violet",

        navItems = [

        ]
    } = data;


    const { mainContent, footer } = slots;

    const router = useRouter()
    const routeTo = url => router.push(url);

    // console.log("NMav Items", navItems);

    // 主要是一个 Header
    const [scrolledUp, setScrolledUp] = useState(false);
    const scrolledUpRef = useRef();
    scrolledUpRef.current = scrolledUp;

    const scrollHelperRef = useRef();

    useEffect(() => {

        scrollHelperRef.current = new WindowScrollHelper({

            onReady: status => {
                const THRESHOLD = 24;
                const scrolledUp = scrolledUpRef.current;
                if (status.y < THRESHOLD && scrolledUp) {
                    setScrolledUp(false)
                } else if (status.y >= THRESHOLD && !scrolledUp) {
                    setScrolledUp(true)
                }
            },

            onScrolled: status => {
                const THRESHOLD = 24;
                const scrolledUp = scrolledUpRef.current;
                if (status.y < THRESHOLD && scrolledUp) {
                    setScrolledUp(false)
                } else if (status.y >= THRESHOLD && !scrolledUp) {
                    setScrolledUp(true)
                }
            }
        })

        return _ => {
            scrollHelperRef.current.cleanUp();
        }

    }, []);





    function isActive(url) {
        return pathname == url;
    }


    function gotoTry() {
        // routeTo(tryUrl);
        track("home_try");
        
        if (tryButtonOpenNewWindow) {
            window.open(tryUrl);
        } else {
            routeTo(tryUrl)
        }
    }

    function renderWide() {
        return (
            <div className="h-full hidden md:flex items-center px-6 gap-6 justify-between w-full max-w-6xl">
                <Link to={homeUrl || "/"} className="flex gap-1 items-center">
                    <Image alt={"logo"}
                        className={clsx("transition-all duration-450 light-only w-auto", {
                            "h-10": !scrolledUp && !siteName,
                            "h-8": scrolledUp && !siteName,
                            "h-[34px]": !scrolledUp && siteName,
                            "h-[29px]": scrolledUp && siteName,
                        })
                    } src={getImageURL(logoPC, "medium")} />
                    <Image alt={"logo"}
                        className={clsx("transition-all duration-450 dark-only w-auto", {
                            "h-10": !scrolledUp && !siteName,
                            "h-8": scrolledUp && !siteName,
                            "h-[34px]": !scrolledUp && siteName,
                            "h-[29px]": scrolledUp && siteName,
                        })
                    } src={getImageURL(logoPCForDark || logoPC, "medium")} />
                    {siteName ? (
                        <div className={clsx(
                            "font-medium break-keep", {
                            "font-size-18": !scrolledUp,
                            "font-size-16": scrolledUp
                        }
                        )}>{siteName}</div>
                    ) : null}
                </Link>
                <div className="flex items-center gap-4">
                    <div className={clsx("flex transition-all duration-300", scrolledUp ? "font-size-14" : "font-size-15")}>
                        {navItems.map(item => {
                            const { label, url, subItems, openWithNewTab } = item;
                            if (url) {
                                return (
                                    <Link to={url} key={label} className="trk-topnav trk-topnav-wide" openWithNewTab={openWithNewTab}>
                                        <div className={clsx(
                                            "px-4 py-2 rounded",
                                            {
                                                "hover:bg-[var(--mauve-3)] cursor-pointer": true,
                                                "font-medium": isActive(url),
                                            }
                                        )}>
                                            {item.label}
                                        </div>
                                    </Link>
                                )
                            } else if (subItems) {
                                const items = subItems.map(({ label, url, openWithNewTab }) => {
                                    return {
                                        label, onSelect: _ => {
                                            if (openWithNewTab) {
                                                window.open(url);
                                            } else {
                                                routeTo(tryUrl)
                                            }
                                        }
                                    }
                                });
                                return (
                                    <DropdownMenu key={label} items={items} className={"!px-3 !py-2.5 font-size-14"}>
                                        <div className={clsx(
                                            "pl-4 pr-3 py-2 rounded flex gap-1.5 items-center",
                                            {
                                                "hover:bg-[var(--mauve-3)] cursor-pointer": true,
                                                "font-medium": isActive(url),
                                            }
                                        )}>
                                            {item.label}
                                            <i className='bx bx-chevron-down'></i>
                                        </div>
                                    </DropdownMenu>
                                )

                            } else {
                                return null
                            }
                        })}
                    </div>
                    <div>
                        <Button
                            id="btn-try-at-wide-topnav"
                            size={scrolledUp ? "small" : "normal"}
                            onPress={gotoTry}
                            className={clsx(
                                "transition-all duration-300",
                                "trk-btn-try",
                                {
                                    "!px-3": scrolledUp
                                }
                            )}
                            appearance="primary" color={mainColor}>{tryButtonLabel}</Button>
                    </div>
                </div>
            </div>
        )
    }

    const [narrowMenuShown, setNarrowMenuShown] = useState(false);

    const defaultOverflowRef = useRef();
    useEffect(() => {
        if (typeof (document) !== "undefined") {
            if (narrowMenuShown) {
                defaultOverflowRef.current = document.body.style["overflow"];
                document.body.style["overflow"] = "hidden";
            } else {
                document.body.style["overflow"] = defaultOverflowRef.current;
            }
        }

    }, [narrowMenuShown]);

    function renderNarrow() {
        return (
            <>
                <div className={clsx(
                    "absolute top-0 w-full transition-all h-screen opacity-30 bg-[var(--mauve-11)]",
                    {
                        "hidden": !narrowMenuShown,
                    }
                )} onClick={_ => setNarrowMenuShown(false)} />
                <div className={clsx("h-full flex md:hidden items-center w-full relative", {
                    "bg-[var(--lc-color-bg-1)]": narrowMenuShown
                })}>
                    <div className={clsx("flex items-center pl-3 pr-4 gap-6 justify-between w-full")}>
                        <Link to={homeUrl || "/"} className="flex gap-1 items-center">
                            <Image width={40} height={40} alt={"logo"}
                                className={clsx("transition-all duration-300", {
                                    "h-11 w-11": !scrolledUp || narrowMenuShown,
                                    "h-10 w-10": scrolledUp && !narrowMenuShown
                                })
                            } src={getImageURL(logoMobile, "medium")} />

                            {siteName ? (
                                <div className={clsx(
                                    "font-medium break-keep", {
                                    "font-size-18": !scrolledUp,
                                    "font-size-16": scrolledUp
                                }
                                )}>{siteName}</div>
                            ) : null}
                        </Link>
                        <div className="flex items-center gap-6">
                            {navItems && navItems.length > 0 ? (
                                <div className="flex flex-col justify-between h-5 w-6 py-0.5 overflow-hidden" onClick={_ => {
                                    setNarrowMenuShown(prev => !prev);
                                }}>
                                    {[1, 2, 3].map(i => {
                                        return (
                                            <div key={i} className={clsx(
                                                "h-0.5 bg-[var(--mauve-11)] transition-all w-[200%]",
                                                narrowMenuShown ? {
                                                    "-translate-x-[2px] -rotate-45": i == 1,
                                                    "opacity-0": i == 2,
                                                    "-translate-x-[2px] rotate-45": i == 3,
                                                } : null
                                            )} />
                                        )
                                    })}
                                </div>
                            ) : null}
                            <Button
                                id="btn-try-at-narrow-topnav"
                                size={scrolledUp ? "small" : "normal"}
                                onPress={gotoTry}
                                className={clsx(
                                    "transition-all duration-300",
                                    "trk-btn-try",
                                    {
                                        "!px-3": scrolledUp && !narrowMenuShown
                                    }
                                )}
                                appearance="primary" color={mainColor}>{tryButtonLabel}</Button>
                        </div>
                    </div>
                    <div className={clsx(
                        "absolute top-[100%] w-full transition-all origin-top-left px-4 pt-6 pb-12",
                        "flex flex-col bg-[var(--lc-color-bg-1)] shadow-md gap-4",
                        {
                            "scale-y-0": !narrowMenuShown,
                            "scale-y-100": narrowMenuShown
                        }
                    )}>
                        {navItems.map(item => {
                            const { label, url, subItems } = item;
                            if (url) {
                                return (
                                    <Link to={url} key={label} className="trk-topnav trk-topnav-narrow">
                                        <div className={clsx(
                                            "px-4 py-2 rounded",
                                            {
                                                "hover:bg-[var(--mauve-3)] cursor-pointer": true,
                                                "font-medium": isActive(url),
                                            }
                                        )} onClick={e => {
                                            setNarrowMenuShown(false);
                                        }}>
                                            {label}
                                        </div>
                                    </Link>
                                )
                            } else if (subItems) {
                                return (
                                    <SubMenu key={label} label={label} subItems={subItems} closeMenu={_ => setNarrowMenuShown(false)} isActive={isActive} />
                                )
                            }
                            return null;
                        })}
                    </div>
                </div>
            </>
        )
    }

    return (
        <DataLoaderProvider>
            <Suspense>
                <HandleReferral />
            </Suspense>
            <div className="w-full flex flex-col font-size-14 min-h-full">
                {mainContent || null}
                {footer || null}
                <div className={clsx(
                    "w-full fixed border-b-[1px] transition-all flex justify-center",
                    "hover:bg-[var(--lc-color-bg-1)] hover:border-b-[(var(--gray-3)",
                    {
                        "bg-transparent h-20 sm:h-24 !border-b-[transparent]": (!scrolledUp || narrowMenuShown),
                        "bg-[var(--lc-color-bg-1)] h-14 border-b-[(var(--gray-3)]": (scrolledUp && !narrowMenuShown),
                    }
                )}>
                    {renderWide()}
                    {renderNarrow()}
                </div>
            </div>
        </DataLoaderProvider>
    )
}


function SubMenu({ subItems, label, closeMenu, isActive }) {

    const [open, setOpen] = useState(true);

    return (
        <div className="w-full h-full flex flex-col">
            <div key={label} className={clsx(
                "px-4 py-2 rounded justify-between flex items-center",
                {
                    // "hover:bg-[var(--mauve-3)] cursor-pointer": true,
                    // "font-medium": isActive(url),
                }
            )} onClick={e => {
                // setNarrowMenuShown(false);
                setOpen(prev => !prev);
            }}>
                {label}
                {open ? (
                    <i className='bx bx-chevron-up'></i>
                ) : (
                    <i className='bx bx-chevron-down'></i>
                )}
            </div>
            {open ? (
                <div className="w-full pt-4 px-4">
                    {subItems.map(({ label, url, openWithNewTab }) => {
                        return (
                            <Link to={url} key={label} openWithNewTab={openWithNewTab} className={clsx(
                                "px-4 py-2 rounded justify-between flex items-center",
                                {
                                    "hover:bg-[var(--mauve-3)] cursor-pointer": true,
                                    "font-medium": isActive(url),
                                }
                            )} onClick={e => {
                                closeMenu();
                            }}>
                                {label}
                            </Link>
                        )

                    })}
                </div>
            ) : null}
        </div>
    )

} 




// Handle Referral
function HandleReferral() {
    const searchParams = useSearchParams();

    // 如果有 ur 则存在 loadStorage
    useEffect(() => {
        if (typeof (window) !== "undefined") {
            if (searchParams.get("ur")) {
                localStorage.setItem("user-ref", searchParams.get("ur"));
            }
            if (searchParams.get("cr")) {
                localStorage.setItem("channel-ref", searchParams.get("cr"));
            }
        }

    }, []);

    return null;

}